export default __webpack_public_path__ + "static/media/brand-logo.c27ae98e.png";